// source: pbtypes/gen/telit_lte_modem/cellular_attachment_metadata.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_telit_lte_modem_available_update_pb = require('../../../pbtypes/gen/telit_lte_modem/available_update_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_available_update_pb);
var pbtypes_gen_vehicle_updates_ota_progress_pb = require('../../../pbtypes/gen/vehicle_updates/ota_progress_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_updates_ota_progress_pb);
goog.exportSymbol('proto.telit_lte_modem.CellularAttachmentMetadata', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telit_lte_modem.CellularAttachmentMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.telit_lte_modem.CellularAttachmentMetadata.repeatedFields_, null);
};
goog.inherits(proto.telit_lte_modem.CellularAttachmentMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telit_lte_modem.CellularAttachmentMetadata.displayName = 'proto.telit_lte_modem.CellularAttachmentMetadata';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.telit_lte_modem.CellularAttachmentMetadata.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.telit_lte_modem.CellularAttachmentMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telit_lte_modem.CellularAttachmentMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularAttachmentMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
imei: jspb.Message.getFieldWithDefault(msg, 1, ""),
selectedIccidIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccidsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
availableUpdate: (f = msg.getAvailableUpdate()) && pbtypes_gen_telit_lte_modem_available_update_pb.AvailableUpdate.toObject(includeInstance, f),
otaProgress: (f = msg.getOtaProgress()) && pbtypes_gen_vehicle_updates_ota_progress_pb.OtaProgress.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telit_lte_modem.CellularAttachmentMetadata;
  return proto.telit_lte_modem.CellularAttachmentMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telit_lte_modem.CellularAttachmentMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImei(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSelectedIccidIndex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addIccids(value);
      break;
    case 4:
      var value = new pbtypes_gen_telit_lte_modem_available_update_pb.AvailableUpdate;
      reader.readMessage(value,pbtypes_gen_telit_lte_modem_available_update_pb.AvailableUpdate.deserializeBinaryFromReader);
      msg.setAvailableUpdate(value);
      break;
    case 5:
      var value = new pbtypes_gen_vehicle_updates_ota_progress_pb.OtaProgress;
      reader.readMessage(value,pbtypes_gen_vehicle_updates_ota_progress_pb.OtaProgress.deserializeBinaryFromReader);
      msg.setOtaProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telit_lte_modem.CellularAttachmentMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telit_lte_modem.CellularAttachmentMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularAttachmentMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSelectedIccidIndex();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getIccidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getAvailableUpdate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_telit_lte_modem_available_update_pb.AvailableUpdate.serializeBinaryToWriter
    );
  }
  f = message.getOtaProgress();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_vehicle_updates_ota_progress_pb.OtaProgress.serializeBinaryToWriter
    );
  }
};


/**
 * optional string imei = 1;
 * @return {string}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sint32 selected_iccid_index = 2;
 * @return {number}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.getSelectedIccidIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.setSelectedIccidIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string iccids = 3;
 * @return {!Array<string>}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.getIccidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.setIccidsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.addIccids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.clearIccidsList = function() {
  return this.setIccidsList([]);
};


/**
 * optional AvailableUpdate available_update = 4;
 * @return {?proto.telit_lte_modem.AvailableUpdate}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.getAvailableUpdate = function() {
  return /** @type{?proto.telit_lte_modem.AvailableUpdate} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_telit_lte_modem_available_update_pb.AvailableUpdate, 4));
};


/**
 * @param {?proto.telit_lte_modem.AvailableUpdate|undefined} value
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
*/
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.setAvailableUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.clearAvailableUpdate = function() {
  return this.setAvailableUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.hasAvailableUpdate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional vehicle_updates.OtaProgress ota_progress = 5;
 * @return {?proto.vehicle_updates.OtaProgress}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.getOtaProgress = function() {
  return /** @type{?proto.vehicle_updates.OtaProgress} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_updates_ota_progress_pb.OtaProgress, 5));
};


/**
 * @param {?proto.vehicle_updates.OtaProgress|undefined} value
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
*/
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.setOtaProgress = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.telit_lte_modem.CellularAttachmentMetadata} returns this
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.clearOtaProgress = function() {
  return this.setOtaProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.telit_lte_modem.CellularAttachmentMetadata.prototype.hasOtaProgress = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.telit_lte_modem);
